import { render } from "./PanelGroup.vue?vue&type=template&id=75893d87&scoped=true"
import script from "./PanelGroup.vue?vue&type=script&lang=js"
export * from "./PanelGroup.vue?vue&type=script&lang=js"

import "./PanelGroup.vue?vue&type=style&index=0&id=75893d87&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-75893d87"

export default script